export default "__VITE_ASSET__CDxFy34D__"